import React from 'react';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import { EnumField, FullDateField, LongTextField, TextField } from 'framework/ui/field';
import useProcessIncidentService, {
  ProcessIncidentTypeLabels,
} from 'domain/gpo/cockpit/instance/Show/incident/processIncidentService';
import ResolveBusinessIncidentButton from './shared/button/ResolveBusinessIncidentButton';

const IncidentsTable = () => {
  const { getIncidents } = useProcessIncidentService();

  const getDataMethod = async () => {
    const incidents = await getIncidents();
    return incidents;
  };

  return (
    <RelatedList getDataMethod={getDataMethod}>
      <RelationListLayout header="Active Incidents" actions={[]}>
        <DataGridLayout
          showTotal={false}
          sxTableWrapper={{
            '& td span': {
              whiteSpace: 'pre-wrap',
            },
          }}
          buttons={[<ResolveBusinessIncidentButton sourceId="id" />]}
          isSmallTable
        >
          <TextField source="id" label="Id" />
          <FullDateField source="incidentTimestamp" label="Timestamp" />
          <EnumField source="incidentType" label="Type" options={ProcessIncidentTypeLabels} />
          <TextField label="Activity ID" source="activityId" />
          <LongTextField source="incidentMessage" label="Message" title="Message" />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedList>
  );
};

export default IncidentsTable;
